import React, { Component } from "react";
import { Modal } from "react-bootstrap";

const styles = {
    header: {
        background: "linear-gradient(135deg, #ef4444, #dc2626)",
        border: "none",
        padding: "16px 20px",
        display: "flex",
        alignItems: "center",
        gap: 12,
    },
    headerIcon: {
        width: 38,
        height: 38,
        background: "rgba(255,255,255,0.18)",
        borderRadius: 9,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: 18,
        flexShrink: 0,
    },
    headerTitle: {
        fontSize: 15,
        fontWeight: 800,
        color: "#fff",
        margin: 0,
    },
    headerSub: {
        fontSize: 11,
        color: "rgba(255,255,255,0.72)",
        margin: "2px 0 0",
    },
    body: {
        padding: "28px 24px 20px",
        textAlign: "center",
    },
    warningCircle: {
        width: 64,
        height: 64,
        background: "#fef2f2",
        borderRadius: "50%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        margin: "0 auto 16px",
        fontSize: 28,
    },
    message: {
        fontSize: 15,
        fontWeight: 700,
        color: "#1e293b",
        margin: "0 0 6px",
    },
    subMessage: {
        fontSize: 12,
        color: "#64748b",
        margin: "0 0 24px",
    },
    btnRow: {
        display: "flex",
        gap: 10,
        justifyContent: "center",
    },
    btnCancel: {
        background: "#fff",
        border: "1.5px solid #e2e8f0",
        color: "#64748b",
        padding: "9px 24px",
        borderRadius: 8,
        fontSize: 13,
        fontWeight: 600,
        cursor: "pointer",
        transition: "all 0.18s",
    },
    btnDelete: {
        background: "linear-gradient(135deg, #ef4444, #dc2626)",
        color: "#fff",
        border: "none",
        padding: "9px 24px",
        borderRadius: 8,
        fontSize: 13,
        fontWeight: 700,
        cursor: "pointer",
        display: "inline-flex",
        alignItems: "center",
        gap: 8,
        boxShadow: "0 3px 10px rgba(239,68,68,0.3)",
        transition: "all 0.18s",
    },
    successBanner: {
        display: "flex",
        alignItems: "center",
        gap: 8,
        background: "#d1fae5",
        border: "1px solid #6ee7b7",
        color: "#065f46",
        borderRadius: 8,
        padding: "9px 14px",
        fontSize: 13,
        fontWeight: 600,
        marginTop: 16,
        justifyContent: "center",
    },
    errorBanner: {
        display: "flex",
        alignItems: "center",
        gap: 8,
        background: "#fef2f2",
        border: "1px solid #fca5a5",
        color: "#991b1b",
        borderRadius: 8,
        padding: "9px 14px",
        fontSize: 13,
        fontWeight: 600,
        marginTop: 16,
        justifyContent: "center",
    },
};

class DiaryTableRowDeleteModal extends Component {
    constructor(props) {
        super(props)
        this.state = {}
    }

    render() {
        const { stateData, handleDelete, onHide } = this.props;
        const isDeleted = stateData.currentStep == 5;
        const isDeleting = stateData.spinnerStatus === "1";

        return (
            <Modal {...this.props} size="sm" aria-labelledby="delete-modal-title">

                {/* ── Header ── */}
                <Modal.Header closeButton style={styles.header}>
                    <div style={styles.headerIcon}>🗑️</div>
                    <div>
                        <p style={styles.headerTitle}>Delete Entry</p>
                        <p style={styles.headerSub}>This action cannot be undone</p>
                    </div>
                </Modal.Header>

                {/* ── Body ── */}
                <Modal.Body style={styles.body}>
                    <div style={styles.warningCircle}>⚠️</div>
                    <p style={styles.message}>Are you sure you want to delete?</p>
                    <p style={styles.subMessage}>
                        Once deleted, this entry will be permanently removed.
                    </p>

                    <div style={styles.btnRow}>
                        <button
                            style={styles.btnCancel}
                            onClick={onHide}
                            disabled={isDeleting}
                        >
                            Cancel
                        </button>
                        <button
                            style={styles.btnDelete}
                            onClick={handleDelete}
                            disabled={isDeleting || isDeleted}
                        >
                            {isDeleting && (
                                <span className="spinner-border spinner-border-sm" />
                            )}
                            <i className="far fa-trash-alt" />
                            {isDeleting ? "Deleting..." : "Yes, Delete"}
                        </button>
                    </div>

                    {isDeleted && (
                        <div style={styles.successBanner}>
                            <i className="fas fa-check-circle" />
                            Deleted successfully!
                        </div>
                    )}

                    {stateData.submitError && !isDeleted && (
                        <div style={styles.errorBanner}>
                            <i className="fas fa-times-circle" />
                            {stateData.submitError}
                        </div>
                    )}
                </Modal.Body>
            </Modal>
        )
    }
}

export default DiaryTableRowDeleteModal;
